import { MATERIAL_VIEWS } from '../../../common/base-search-result/base-search-result.constants';
import qualityEventsHelpers from '../quality-events.helpers';

export const FAVORITES_PAGE_QUALITY_EVENTS = {
    createFavoritesList() {
        qualityEventsHelpers.track({ type: 'createFavoritesList', extra: getExtra() });
    },
    clickFavoritesList(favoritesCount: number) {
        qualityEventsHelpers.track({ type: 'clickFavoritesList', extra: getExtra({ favorites_count: favoritesCount }) });
    },
    clickMaterialFromFavorites({ item, itemIndex }: { item: Material; itemIndex: number }) {
        qualityEventsHelpers.track({
            type: 'clickMaterialFromFavorites',
            extra: getExtra(),
            ...qualityEventsHelpers.extractMaterialsData(item, { itemIndex })
        });
    },
    viewFavorites({ from }: { from: 'header_icon' | 'profil_menu' }) {
        qualityEventsHelpers.track({ type: 'viewFavorites', extra: getExtra({ from }) });
    },
    addToFavorites(material: Material, materialIndex?: number, from?: 'fromMaterialPage' | 'fromFavorites') {
        qualityEventsHelpers.track({
            ...qualityEventsHelpers.extractMaterialsData(material, { itemIndex: materialIndex }),
            extra: from && JSON.stringify({ from }),
            type: 'addToFavorites'
        });
    },
    removeFromFavorites(material: Material, materialIndex?: number, from?: 'fromMaterialPage' | 'fromFavorites') {
        qualityEventsHelpers.track({
            ...qualityEventsHelpers.extractMaterialsData(material, { itemIndex: materialIndex }),
            extra: from && JSON.stringify({ from }),
            type: 'removeFromFavorites'
        });
    },
    changeView(newView: MATERIAL_VIEWS):void {
        qualityEventsHelpers.track({
            extra: newView,
            type: 'changeViewInFavorites'
        });
    }
};

const getExtra = (extraFields: Record<string, string | number> = {}): string | null =>
    JSON.stringify({ ...getDateAndTime(), ...extraFields });
const getDateAndTime = (): Record<string, string | number> => {
    const now = new Date();

    return {
        date: now.toISOString(),
        time: now.getTime()
    };
};
